export default {

 badge: "سوالات متداول",
    title: "چطور می‌توانیم کمکتان کنیم؟",
    subtitle: "در این بخش به برخی از پرتکرارترین سوالات شما پاسخ داده‌ایم.",
    items: [
      {
        question: "چگونه در وب‌سایت ثبت‌نام کنم؟",
        answer: "برای ثبت‌نام، کافیست روی دکمه «ثبت‌نام» در بالای صفحه کلیک کرده و فرم مربوطه را با اطلاعات دقیق خود تکمیل نمایید. پس از تایید ایمیل، حساب کاربری شما فعال خواهد شد.",
      },
      {
        question: "چگونه خرید خود را انجام دهم؟",
        answer: "پس از انتخاب محصول مورد نظر، آن را به سبد خرید اضافه کنید. سپس به صفحه سبد خرید رفته و با کلیک بر روی دکمه «پرداخت نهایی» و دنبال کردن مراحل، خرید خود را تکمیل نمایید. برای راهنمایی بیشتر، ویدئو آموزشی <a href='#'>اینجا</a> موجود است.",
      },
      {
        question: "چگونه فایل‌های صوتی (ویس‌ها) را دانلود کنم؟",
        answer: "پس از خرید هر دوره یا محصول، لینک دانلود فایل‌های صوتی در صفحه «حساب کاربری من» و در بخش «محصولات خریداری شده» قابل دسترس خواهد بود. با کلیک روی دکمه دانلود، فایل مربوطه ذخیره می‌شود.",
      },
      {
        question: "آیا امکان ویرایش اطلاعات حساب کاربری وجود دارد؟",
        answer: "بله، شما می‌توانید پس از ورود به حساب کاربری خود، به بخش «پروفایل من» رفته و اطلاعات خود شامل نام، ایمیل و رمز عبور را ویرایش نمایید.",
      },
      {
        question: "چگونه با پشتیبانی تماس بگیرم؟",
        answer: "برای تماس با پشتیبانی، می‌توانید از طریق صفحه «تماس با ما» یا ارسال ایمیل به آدرس support@zabankid.com اقدام فرمایید. ساعات پاسخگویی ما نیز در صفحه تماس مشخص شده است.",
      },
    ],
};
